var Reverb = window.Reverb || {};
Reverb.CharacterLimit = function () {
  var fieldSelector = '[data-character-limit]';
  var characterLeftCounter = '[data-characters-left]';
  var charCounter = '[data-character-counter]';

  function init() {
    limitFieldCharacters();
    bindFocusEvents();
  }

  function limitFieldCharacters() {
    var field = $(fieldSelector),
      charLimit = field.prop('maxlength');

    if (field.length > 0) {
      field.limit(charLimit, characterLeftCounter);
    }
  }

  function bindFocusEvents() {
    $(document).on('focus', fieldSelector, function () {
      $(charCounter).fadeIn();
    });

    $(document).on('blur', fieldSelector, function () {
      $(charCounter).fadeOut();
    });
  }

  return {
    init: init
  };
}();

$(Reverb.CharacterLimit.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/character_limit.js